module.exports = __webpack_public_path__ + "img/modus.ba7abd1f.png";